import { type Locale, locales } from "@/i18n/routing";

export function stripLocalePrefix(path: string): string {
  for (const locale of locales) {
    if (path.startsWith(`/${locale}/`)) return path.slice(locale.length + 1);
    if (path === `/${locale}`) return "/";
  }
  return path;
}

export function localeFromPath(path: string): Locale | undefined {
  return locales.find((locale) => path === `/${locale}` || path.startsWith(`/${locale}/`));
}
